import { useFormik } from 'formik';
import { initialValues } from './formData';
import { validationSchema } from './formData';
import { MultiDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface StyleAndTonalityForm {
    [key: string]: MultiDynamicField[];
}

export const useStyleAndTonality = (chatAssistant: ChatAssistant) => {
    const formikStyleAndTonality = useFormik<StyleAndTonalityForm>({
        initialValues,
        validationSchema,
        onSubmit: console.log,
    });

    useEffect(() => {
        if (chatAssistant) {
            formikStyleAndTonality.setValues({
                styleAndTonality:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.styleAndTonality ?? initialValues.styleAndTonality,
            });
        }
    }, [chatAssistant]);

    return { formikStyleAndTonality };
};
